//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    ALERT_TYPES_DETAILS_REQUEST,
    ALERT_TYPES_DEVICE_MODEL_REQUEST,
    ALERT_TYPES_UPDATE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    alertTypesDetailsResult,
    alertTypesDeviceModelResult,
    alertTypesUpdateResult,
} from 'Redux/actions';

function* getAlertType({ payload }) {
    const { id } = payload
    try {
        let QUERY = `
            query getAlertType ($id: Int!) {
                result: getAlertType (id: $id) {
                    id
                    name
                    code
                    createdOn
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(alertTypesDetailsResult(data.result))

    } catch (exc) {
        yield put(alertTypesDetailsResult())
        ExceptionManager(exc, 'Modules/alertTypes/views/main/.components/alertTypeDetails/redux/saga', 'getAlertType');
    }
}

function* searchDeviceModelAlertTypes({ payload }) {
    const { id, name } = payload

    let QUERY = `
        query searchDeviceModelAlertTypes ($conditions: [DeviceModelAlertTypeSearchInput], $sort: [DeviceModelAlertTypeSortInput], $limit: Int, $offset: Int) {
            result: searchDeviceModelAlertTypes (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    deviceModelId
                    deviceModel {
                        id
                        name
                        product
                        manufacturer {
                            id
                            name
                        }
                    }
                }
                total
            }
        }
    `
    let conditions = [{
        fields: ["alertTypeId"],
        terms: [id],
        exact: true,
    }]

    if (name) {
        conditions.push({
            fields: ["deviceModel_name"],
            terms: [name],
            exact: false,
        })
    }

    let data = yield call(
        clientQuery,
        QUERY,
        {
            conditions,
            sort: {
                field: "deviceModel_name",
                order: "ASC"
            },
            limit: 1000,
            offset: 0
        },
        endpoints.GRAPHQL_GENERAL,
    );
    yield put(alertTypesDeviceModelResult(data.result?.items))
}

function* updateAlertType({ payload }) {
    try {
        let QUERY = `
            mutation updateAlertType ($id: String!, $deviceModelIds: [Int]) {
                result: updateAlertType (id: $id, deviceModelIds: $deviceModelIds) {
                    id
                    name
                    code
                }
            }
        `
        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) yield put(alertTypesUpdateResult(data?.result))
        else yield put(alertTypesUpdateResult({ error: true }))

    } catch (exc) {
        yield put(alertTypesUpdateResult({ error: true }))
        ExceptionManager(exc, 'Modules/alertTypes/views/main/.components/alertTypeDetails/redux/saga', 'updateAlertType');
    }
}

export const getDeviceModels = async (input = '') => {
    try {
        let QUERY = `
        query searchDeviceModels ($conditions: [DeviceModelSearchInput], $sort: [DeviceModelSortInput], $limit: Int, $offset: Int) {
            result: searchDeviceModels (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                    manufacturer {
                        id
                        name
                        active
                    }
                    deviceModelAlertTypes {
                        id
                        deviceModelId
                        alertTypeId
                        alertType {
                            id
                            name
                            code
                            parentId
                        }
                    }
                    product
                }
            }
        }
        `
        return await clientQuery(QUERY, {
            conditions: {
                fields: [
                    "name",
                    "manufacturer_name"
                ],
                terms: [
                    input
                ],
                exact: false
            },
            limit: 1000
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/alertTypes/views/main/.components/alertTypeDetails/redux/saga', 'getDeviceModels');
    }
}

function* watchAlertTypesRequests() {
    yield takeEvery(ALERT_TYPES_DETAILS_REQUEST, getAlertType);
    yield takeEvery(ALERT_TYPES_DEVICE_MODEL_REQUEST, searchDeviceModelAlertTypes);
    yield takeEvery(ALERT_TYPES_UPDATE_REQUEST, updateAlertType);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchAlertTypesRequests)
    ]);
}